<template>
    <div class="tab-content">
        <medication-form
            v-show="activeTab === 'network'"
            :availHipaaForms="availHipaaForms"
            :recordTypeSources="recordTypeSources"
            @refresh-record-request="emitEvent({ name: 'refresh-record-request' })"
            @get-hipaa-forms="handleRefreshHipaa"
        ></medication-form>

        <email-form
            v-show="activeTab === 'email'"
            :availHipaaForms="availHipaaForms"
            :recordTypeSources="recordTypeSources"
            @refresh-record-request="emitEvent({ name: 'refresh-record-request' })"
            @get-hipaa-forms="handleRefreshHipaa"
        ></email-form>

        <fax-form
            v-show="activeTab === 'fax'"
            :availHipaaForms="availHipaaForms"
            :recordTypeSources="recordTypeSources"
            @refresh-record-request="emitEvent({ name: 'refresh-record-request' })"
            @get-hipaa-forms="handleRefreshHipaa"
        ></fax-form>
    </div>
</template>
<script>
    import FormMixin from 'mixins/FormMixin'
    import HandleRequestMixin from 'mixins/HandleRequestMixin'
    import MedicationForm from 'components/forms/medication-network/MedicationForm'
    import EmailForm from 'components/forms/email-request/EmailForm'
    import PatientRecordsAPI from '../../../api/PatientRecordsAPI'
    import FaxForm from 'components/forms/fax/FaxForm'

    export default {
        mixins: [FormMixin, HandleRequestMixin],
        components: {
            MedicationForm,
            EmailForm,
            FaxForm,
        },
        props: {
            activeTab: { type: String, required: true },
            availHipaaForms: { type: Array, default: () => [] },
        },

        data() {
            return {
                recordTypeSources: [],
                recordTypeSourcesLoaded: false,
                mountedTabs: {
                    network: false,
                    email: false,
                    fax: false,
                    hipaa: false,
                },
            }
        },

        methods: {
            ensureRequestFormData() {
                if (this.recordTypeSourcesLoaded) {
                    return
                }
                this.getRecordTypeSources()
            },
            handleRefreshHipaa() {
                this.emitEvent({ name: 'refresh-hipaa' })
            },
            getRecordTypeSources() {
                PatientRecordsAPI.getRecordTypeSources().then((res) => {
                    this.recordTypeSources = res.map((item) => ({
                        label: item.name,
                        value: item.id,
                    }))
                    this.recordTypeSourcesLoaded = true
                })
            },
        },

        watch: {
            activeTab: {
                handler(val) {
                    if (val === 'network') {
                        this.mountedTabs.network = true
                        this.ensureRequestFormData()
                    } else if (val === 'email') {
                        this.mountedTabs.email = true
                        this.ensureRequestFormData()
                    } else if (val === 'fax') {
                        this.mountedTabs.fax = true
                        this.ensureRequestFormData()
                    }
                },
                immediate: true,
            },
        },
    }
</script>
